export default "__VITE_ASSET__4aec200a__"